import shop from "../../assets/react-shop.webp";
import pension from "../../assets/pension.webp";
import parus from "../../assets/parus.webp";
import myspace from "../../assets/myspace.webp";
import post from "../../assets/posts.webp";
import realestate from "../../assets/hub-estate.webp";
import fadeeva from "../../assets/fadeeva.webp";

export interface Work {
  title: string,
  description: string,
  categories: string,
  projectLink: string,
  codeLink: string,
  tags: string[],
  imgUrl: string,
}

export interface TranslateWorks {
  en: Work[],
  ua: Work[],
  ru: Work[]
}

export const worksList: TranslateWorks = {
  en: [
    {
      title: "React e-commerce app",
      description: "An E-commerce App that fetches products, categories, and users from a REST API and displays them. The app features search/sort/cart functionalities and ﬁltering, along with a product and user details page.",
      categories: "React App",
      projectLink: "https://pensativa.github.io/react-shop/",
      codeLink: "https://github.com/pensativa/react-shop",
      tags: [
        "React", "TS", "MUI", "Redux", "API"
      ],
      imgUrl: shop,
    },
    {
      title: "Private pension plan website",
      description: "This is a multi-page site that calculates pensions online. Also, you can replenish your pension account or view the report for the desired year or month through it. The site is fully responsive for all mobile devices.",
      categories: "Layout design",
      projectLink: "https://ligapension.com/",
      codeLink: "https://github.com/pensativa/liga_pensia",
      tags: [
        "HTML", "SCSS", "JS", "JQuery", "Bootstrap"
      ],
      imgUrl: pension,
    },
    {
      title: "Real estate website",
      description: "This is a multi-page website with a real estate catalog and information pages. The website also has a mobile version.",
      categories: "Layout design",
      projectLink: "https://myspace.com.cy/en/",
      codeLink: "https://github.com/pensativa/myspace",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap"
      ],
      imgUrl: myspace,
    },
    {
      title: "PAWNSHOP SAIL",
      description: "A multi-page website with a inimalist design. Development of own personal accounts and discount system, and a marketplace for sales of goods.",
      projectLink: "https://lombardparus.com.ua/",
      categories: "Layout design",
      codeLink: "https://github.com/pensativa/parus",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap"
      ],
      imgUrl: parus,
    },
    {
      title: "Posts app",
      description: "An application fetches posts, users, and comments from a REST API and displays them. The app features a search function. The user can search posts by title, and pagination with the possibility to change the count of posts per page, create new comments, and ﬁlter along with a User or Post Details page.",
      categories: "React App",
      projectLink: "https://pensativa.github.io/react-posts-app/",
      codeLink: "https://github.com/pensativa/bof-posts",
      tags: [
        "React", "TS", "TailwindCSS", "API"
      ],
      imgUrl: post,
    },
    {
      title: "Multi-page website with a real estate catalog",
      description: "This is a multi-page website with a real estate catalog and information pages. The website has a navigation menu and animation.",
      categories: "Layout design",
      projectLink: "https://pensativa.github.io/hubestate/",
      codeLink: "https://github.com/pensativa/hubestate",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap", "SwiperJS"
      ],
      imgUrl: realestate,
    },
    {
      title: "Event Host Website",
      description: "A personal project that was completely designed, and transferred to WordPress. The desktop version is made on the principle of a one-page scroll and using the Swiper library.",
      categories: "WordPress",
      projectLink: "http://fadeeva-event.ru/",
      codeLink: "https://github.com/pensativa/fadeeva-new",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap", "SwiperJS", "WordPress"
      ],
      imgUrl: fadeeva,
    }
  ],
  ua: [
    {
      title: "React e-commerce додаток",
      description: "Програма для електронної комерції, яка отримує продукти, категорії та користувачів із REST API та відображає їх. Додаток містить функції пошуку/сортування/кошика та фільтрування, а також сторінку з інформацією про продукт і користувача.",
      categories: "React App",
      projectLink: "https://pensativa.github.io/react-shop/",
      codeLink: "https://github.com/pensativa/react-shop",
      tags: [
        "React", "TS", "MUI", "Redux", "API"
      ],
      imgUrl: shop,
    },
    {
      title: "Сайт з пенсійного планування",
      description: "Це багатосторінковий сайт, який розраховує пенсії онлайн. Також через нього можна поповнити свій пенсійний рахунок або переглянути звіт за потрібний рік чи місяць. Сайт повністю адаптований для всіх мобільних пристроїв.",
      categories: "Верстка сайту",
      projectLink: "https://ligapension.com/",
      codeLink: "https://github.com/pensativa/liga_pensia",
      tags: [
        "HTML", "SCSS", "JS", "JQuery", "Bootstrap"
      ],
      imgUrl: pension,
    },
    {
      title: "Сайт нерухомості",
      description: "Це багатосторінковий веб-сайт з каталогом нерухомості та інформаційними сторінками. Сайт також має мобільну версію.",
      categories: "Верстка сайту",
      projectLink: "https://myspace.com.cy/en/",
      codeLink: "https://github.com/pensativa/myspace",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap"
      ],
      imgUrl: myspace,
    },
    {
      title: "ЛОМБАРД ПАРУС",
      description: "Багатосторінковий веб-сайт з інімалістичним дизайном. Розробка власних особових кабінетів та системи знижок, маркетплейсу для продажу товарів.",
      projectLink: "https://lombardparus.com.ua/",
      categories: "Верстка сайту",
      codeLink: "https://github.com/pensativa/parus",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap"
      ],
      imgUrl: parus,
    },
    {
      title: "Додаток блогу",
      description: "Програма отримує дописи, користувачів і коментарі з REST API і відображає їх. Додаток має функцію пошуку. Користувач може шукати дописи за назвою та розбивкою на сторінки з можливістю змінювати кількість дописів на сторінку, створювати нові коментарі та фільтрувати на сторінці користувача чи інформації про допис.",
      categories: "React App",
      projectLink: "https://pensativa.github.io/react-posts-app/",
      codeLink: "https://github.com/pensativa/bof-posts",
      tags: [
        "React", "TS", "TailwindCSS", "API"
      ],
      imgUrl: post,
    },
    {
      title: "Багатосторінковий сайт з каталогом нерухомості",
      description: "Це багатосторінковий веб-сайт з каталогом нерухомості та інформаційними сторінками. На сайті є навігаційне меню та анімація.",
      categories: "Верстка сайту",
      projectLink: "https://pensativa.github.io/hubestate/",
      codeLink: "https://github.com/pensativa/hubestate",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap", "SwiperJS"
      ],
      imgUrl: realestate,
    },
    {
      title: "Сайт ведучей заходів",
      description: "Персональний проект, який був повністю розроблений і перенесений на WordPress. Десктопна версія виконана за принципом one-page скролу і з використанням бібліотеки Swiper.",
      categories: "WordPress",
      projectLink: "http://fadeeva-event.ru/",
      codeLink: "https://github.com/pensativa/fadeeva-new",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap", "SwiperJS", "WordPress"
      ],
      imgUrl: fadeeva,
    }
  ],
  ru: [
    {
      title: "React e-commerce приложение",
      description: "Приложение электронной коммерции, которое извлекает продукты, категории и пользователей из REST API и отображает их. Приложение имеет функции поиска/сортировки/корзины и фильтрации, а также страницу с данными о продукте и пользователе.",
      categories: "React App",
      projectLink: "https://pensativa.github.io/react-shop/",
      codeLink: "https://github.com/pensativa/react-shop",
      tags: [
        "React", "TS", "MUI", "Redux", "API"
      ],
      imgUrl: shop,
    },
    {
      title: "Сайт по пенсионному планированию",
      description: "Это многостраничный сайт, который рассчитывает пенсии онлайн. Также через него можно пополнить пенсионный счет или посмотреть отчет за нужный год или месяц. Сайт полностью адаптивен для всех мобильных устройств.",
      categories: "Вёрстка сайта",
      projectLink: "https://ligapension.com/",
      codeLink: "https://github.com/pensativa/liga_pensia",
      tags: [
        "HTML", "SCSS", "JS", "JQuery", "Bootstrap"
      ],
      imgUrl: pension,
    },
    {
      title: "Сайт недвижимости",
      description: "Это многостраничный сайт с каталогом недвижимости и информационными страницами. Сайт также имеет мобильную версию.",
      categories: "Вёрстка сайта",
      projectLink: "https://myspace.com.cy/en/",
      codeLink: "https://github.com/pensativa/myspace",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap"
      ],
      imgUrl: myspace,
    },
    {
      title: "ЛОМБАРД ПАРУС",
      description: "Многостраничный сайт с минималистичным дизайном. Разработка личных кабинетов и системы скидок, а также маркетплейса для продажи товаров.",
      projectLink: "https://lombardparus.com.ua/",
      categories: "Вёрстка сайта",
      codeLink: "https://github.com/pensativa/parus",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap"
      ],
      imgUrl: parus,
    },
    {
      title: "Приложение блога",
      description: "Приложение извлекает записи, пользователей и комментарии из REST API и отображает их. Приложение имеет функцию поиска. Пользователь может искать записи по названию и пагинации с возможностью изменять количество записей на странице, создавать новые комментарии и фильтровать вместе со страницей сведений о пользователе или записи.",
      categories: "React App",
      projectLink: "https://pensativa.github.io/react-posts-app/",
      codeLink: "https://github.com/pensativa/bof-posts",
      tags: [
        "React", "TS", "TailwindCSS", "API"
      ],
      imgUrl: post,
    },
    {
      title: "Многостраничный сайт с каталогом недвижимости",
      description: "Это многостраничный сайт с каталогом недвижимости и информационными страницами. Сайт имеет навигационное меню и анимацию.",
      categories: "Вёрстка сайта",
      projectLink: "https://pensativa.github.io/hubestate/",
      codeLink: "https://github.com/pensativa/hubestate",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap", "SwiperJS"
      ],
      imgUrl: realestate,
    },
    {
      title: "Сайт ведущей мероприятий",
      description: "Персональный проект, полностью разработанный и перенесенный на WordPress. Десктопная версия сделана по принципу one-page скролла и с использованием библиотеки Swiper.",
      categories: "WordPress",
      projectLink: "http://fadeeva-event.ru/",
      codeLink: "https://github.com/pensativa/fadeeva-new",
      tags: [
        "HTML", "SCSS", "JS", "Bootstrap", "SwiperJS", "WordPress"
      ],
      imgUrl: fadeeva,
    }
  ]
}